(function () {
  'use strict';

  angular
      .module('tfc.Reports')
      .factory('ReportUtil', ReportUtil);

  // @ngInject
  function ReportUtil($q, $uibModal, Reports, ReportCategories, Month, GaUtil) {

    var FileTypes = {
      'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet': 'xlsx',
      'application/vnd.openxmlformats-officedocument.wordprocessingml.document': 'docx',
      'text/csv': 'csv',
      'application/pdf': 'pdf'
    };

    return {
      validContentTypes : validContentTypes,
      sort : sort,
      fileType : fileType,
      isPreviewable : isPreviewable,
      reportIcon : reportIcon,
      openReport : openReport,
      downloadReport : downloadReport
    };

    function validContentTypes() {
      return _.keys(FileTypes);
    }

    function sort(reports, iteratees, orders) {
      return _.orderBy(reports,
          iteratees || ['tla', byCategory, byKey],
          orders || ['asc', 'asc', 'desc']
      );

      function byCategory(report) {
        return ReportCategories.indexOf(report.key.category);
      }

      function byKey(report) {
        var key = report.key;
        switch (key.category) {
          case 'week':
          case 'month':
          case 'quarter':
            // Not an accurate date in the case of 'quarter', but the sorting will be correct
            return new Date(key.year, (Month.toInt(key.month) || key.quarter) - 1, key.day || 1);
          case 'other':
            return report.key.name;
        }
      }
    }


    function fileType(report) {
      if (!report.isShowMore) {
        return FileTypes[report.contentType];
      }
    }

    function isPreviewable(report) {
      return 'pdf' === fileType(report);
    }

    function reportIcon(report) {
      if (report.isShowMore) {
        return 'fa-ellipsis-h';
      }
      switch (fileType(report)) {
        case 'xlsx':
        case 'csv':
          return 'fa-file-excel-o';
        case 'docx':
          return 'fa-file-word-o';
        case 'pdf':
          return 'fa-file-pdf-o';
        default:
          console.error('Invalid content type', report);
          return 'fa-question';
      }
    }

    function getFileContent(report) {
      // I'm not really clear on the details, but there's a point in the $digest when comparing a File's name
      // before the File has been initialized (or something?), which was throwing a TypeError.
      // Calling this $content tells angular to skip it when dirty checking on the File.
      // https://docs.angularjs.org/api/ng/function/angular.equals
      return Reports.content(report.fileKey, true);
    }

    function openReport(report) {
      // Do this asynchronously so the modal opens immediately, preventing a double click
      var contentPromise;
      var previewable = isPreviewable(report);
      if (previewable) {
        contentPromise = getFileContent(report);
      }
      return $uibModal.open({
        templateUrl: 'Reports/ReportViewer.tmpl.html',
        controllerAs : 'vm',
        controller : function ($scope, $stateParams, Toast, Upload, BrandReports) {
          var vm = this;
          vm.report = report;
          vm.download = function () {
            return BrandReports.selectedBrandKey($stateParams.brandKey).then(function(selectedBrandKey) {
             var brandKey = selectedBrandKey;
              GaUtil.sendGaEvent(brandKey, 'Download Report', 'All Reports Download');
              downloadReport(report);
            });
          };
          vm.close = $scope.$close;
          vm.isPreviewable = previewable;
          if (previewable) {
            contentPromise.then(function (content) {
              vm.content = content;
              // There's a race condition when using ngf-src="vm.content.dataBlob".
              // If the <embed> tag is made visible before Upload creates the dataUrl,
              // it doesn't appear on some computers. Doing it this way fixes that.
              if(vm.content.dataBlob) {
                Upload.dataUrl(vm.content.dataBlob).then(function (url) {
                  vm.content.dataBlobUrl = url;
                });
              } else vm.content.dataBlobUrl = null;
            }, function () {
              Toast.error('reports.downloadFailed');
              vm.close();
            });
          }
        }
      });
    }

    function reportDownload(report) {
      return function (fileContent) {
        return fileContent(report).then(function (content) {
          download(content.dataBlob, content.fileName, "application/vnd-xls");
        });
      }
    }

    function downloadReport(report) {
      return reportDownload(report)(getFileContent);
    }
  }

})();